<template>

    <div class="accountdetails">
        <div class="profile">
            <text-input
                :label="lang('all.bedrijfsnaam')"
                v-model="form.name"
                :errors="errors.name"
                @onEnter="changeProfile"
            ></text-input>

            <div class="row">
                <div class="col-6">
                    <text-input
                        :label="lang('all.voornaam')"
                        v-model="form.firstname"
                        :errors="errors.firstname"
                    ></text-input>
                </div>
                <div class="col-6">
                    <text-input
                        :label="lang('all.achternaam')"
                        v-model="form.lastname"
                        :errors="errors.lastname"
                    ></text-input>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <text-input
                        :label="lang('all.straat')"
                        v-model="form.street"
                        :errors="errors.street"
                    ></text-input>
                </div>
                <div class="col-3">
                    <text-input
                        :label="lang('all.huisnummer')"
                        v-model="form.housenr"
                        :errors="errors.housenr"
                    ></text-input>
                </div>
                <div class="col-3">
                    <text-input
                        :label="lang('all.toevoeging')"
                        v-model="form.housenrext"
                        :errors="errors.housenrext"
                    ></text-input>
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <text-input
                        :label="lang('all.postcode')"
                        v-model="form.zipcode"
                        :errors="errors.zipcode"
                    ></text-input>
                </div>
                <div class="col-5">
                    <text-input
                        :label="lang('all.plaats')"
                        v-model="form.city"
                        :errors="errors.city"
                    ></text-input>
                </div>
                <div class="col-5">
                    <div class="form-group">
                        <label for="country_id" class="control-label">{{ lang('all.land') }}</label>
                        <vue-select
                            class="vselect-box"
                            id="country_id"
                            v-model="form.country_id"
                            :clearable="false"
                            :options="countries.data"
                            :reduce="country => country.uuid"
                            :label="lang('all.name')"
                        ></vue-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <text-input
                        v-model="form.email"
                        :disabled="true"
                        :label="lang('all.je_emailadres')"
                        :description="lang('all.je_emailadres_description')"
                    ></text-input>
                </div>
                <div class="col-6">
                    <text-input
                        v-model="form.taxnumber"
                        :disabled="true"
                        :label="lang('all.je_btw_nummer')"
                        :description="lang('all.je_btw_nummer_description')"
                    ></text-input>
                </div>
            </div>

            <div>
                <button
                    class="btn btn-primary"
                    :disabled="!canChangeProfile"
                    @click="changeProfile"
                >
                    {{ lang('all.profiel_wijzigen') }}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <change-password></change-password>
            </div>
            <div class="col-md-6">
                <preferred-locale
                    :preferred-locale="details.data.preferred_locale"
                ></preferred-locale>
                <mailinglist
                    :is-subscribed="mailinglist"
                ></mailinglist>
            </div>
        </div>
    </div>

</template>

<script>

import MyAccountLayout from "../../../../Shared/Auth/MyAccount/Layout";
import TextInput from "../../../../Common/TextInput";
import ChangePassword from "../../../../components/MyAccount/ChangePassword";
import Mailinglist from "../../../../components/MyAccount/Mailinglist";
import PreferredLocale from "../../../../components/MyAccount/PreferredLocale";
import vueSelect from 'vue-select';

export default {

    components: {
        TextInput,
        ChangePassword,
        Mailinglist,
        PreferredLocale,
        vueSelect,
    },

    computed: {
        canChangeProfile() {
            return this.posting === false;
        },
        changeProfileFormData() {
            return this.form;
        },
        errors() {
            return this.$page.props.errors;
        },
    },

    data() {
        return {
            form: {
                name:'',
                firstname:'',
                lastname:'',
                street:'',
                housenr:'',
                housenrext:'',
                city:'',
                zipcode:'',
                email:'',
                taxnumber:'',
                country_id:null,
            },
            posting:false,
        }
    },

    layout:MyAccountLayout,

    metaInfo: {
        title: 'Mijn accountgegevens'
    },

    methods: {
        changeProfile() {
            if (!this.canChangeProfile) {
                return;
            }
            this.posting = true;
            this.$inertia.post(this.route('auth.myaccount.details.profile.store'), this.changeProfileFormData, {
                onFinish: () => this.posting = false,
            });
        }
    },

    mounted(){
        this.form = JSON.parse(JSON.stringify(this.details.data));
    },

    name:'AuthMyAccountDetailsIndex',

    props: {
        countries: {
            type:Object,
            required:true,
        },
        details: {
            type:Object,
            required:true,
        },
        mailinglist: {
            required:true,
            type:Boolean,
        },
    },

}

</script>
